import { NAMESPACE_LIVE } from 'app/constants/Context';
import createSelectors from 'app/redux/betting-presentation/grid/selectors';

import * as entitySelectors from './entities';

export const {
  sportIds,
  mainLineId,
  matchSportId,
  stakeLayout,
  gridSubheaderBreadcrumbSelector,
  stakeTypeGroupBySportId,
  innerLinesScores,
  matchMainScoresSelector,
  stakeSlotsSelector,
  stakeSlotsWithMainStakesSelector,
  stakeSlotsNumberOfBetSelector,
  matchStakesSelector,
  createGridHeaderSelector,
  allSportsGridSelector,
  stagesSortedByTournamentsGroupedByPromotionLevelSelector,
  tournamentsGroupedByPromotionLevelBySportIdsSortingByPrioritySelector,
  tournamentsWithStreamsPromotionLevelBySportIdsSortingByPrioritySelector,
  matchesWithStreamsSelector,
  stageGridSelector,
  allStageGridSelector,
  stagesSortedByGroupedTournamentsBySportIdSelector,
  tournamentMatchIdsSelector,
  matchInnerLineListSelector,
  visibleLineStakeIdsSelector,
  innerLineListWithNoEmptyLinesSelector,
  lineOptionsWithNumberOfBetsSelector,
  createVisibleStakeTypeGroupIdsSelector,
  transparentSpaceWidthSelector,
  mainCellWidthSelector,
} = createSelectors(NAMESPACE_LIVE, entitySelectors, { path: ['grid'] });
